// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jh-0";
export var buttonContainer = "_jh-3";
export var cancelButton = "_jh-4";
export var headerSection = "_jh-6";
export var headerTitle = "_jh-9";
export var messageSideLeft = "_jh-1";
export var messageSideRight = "_jh-2";
export var orderNumberContainer = "_jh-7";
export var orderNumberLabel = "_jh-8";
export var submitButton = "_jh-5";